<template>
    <div class="page">
        <ion-grid fixed v-if="station">
        <ion-row class="row-divider"></ion-row>
        <ion-row class="rectangle">
            <ion-col>
            <ion-row align-items-stretch>
                <ion-col class="col-padding">
                <ion-label class="section-head">Basic Details</ion-label>
                </ion-col>
            </ion-row>
            <ion-row align-items-stretch>
                <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">Station ID</ion-label>
                <div class="section-desc margin-top-10">{{station.id}}</div>
                </ion-col>
                <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">Station Name<span v-if="station.rating != 0">&nbsp;<ion-icon  class="star-rating" name="star"></ion-icon>{{station.rating}}</span></ion-label>
                <div class="section-desc margin-top-10">{{station.name}}</div>
                </ion-col>
                <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">Effective From</ion-label>
                <div
                    class="section-desc margin-top-10"
                >{{changeDateFormatWithoutTime(station.effectiveOn)}}</div>
                </ion-col>
                <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">Last Effective Date</ion-label>
                <div
                    class="section-desc margin-top-10"
                >{{changeDateFormatWithoutTime(station.effectiveTill)}}</div>
                </ion-col>
                <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">Distribution Node</ion-label>
                <div class="section-desc margin-top-10">{{station.distributionNode}}</div>
                </ion-col>
                <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">Status</ion-label>
                <div class="section-desc status-small margin-top-10"
                    v-bind:class="[{'status-new': station.status.id == 'G'}, {'status-removed': station.status.id == 'R'}, {'status-active': station.status.id == 'A'}, {'status-inactive': station.status.id == 'I'}]"
                >{{convertUppercase(station.status.name)}}</div>
                </ion-col>
                <ion-col size="12" size-md="3" class="col-padding">
                <!-- <ion-label class="section-item" position="stacked">Visible To All</ion-label> -->
                <ion-label class="section-item" position="stacked">Captive</ion-label>
                <div class="section-desc margin-top-10">{{station.visibilityStatus.name}}</div>
                </ion-col>
                <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">Third Party Status</ion-label>
                <div class="section-desc margin-top-10">{{station.thirdPartyStatus.name}}</div>
                </ion-col>
                <ion-col size="12" size-md="3" class="col-padding" v-if="station.thirdPartyStatus.id != 'N'">
                <ion-label class="section-item" position="stacked">Third Party Name</ion-label>
                <div class="section-desc margin-top-10">{{station.thirdPartyInfo.name}}</div>
                </ion-col>
            </ion-row>
            <hr />
            <ion-row align-items-stretch>
                <ion-col class="col-padding">
                <ion-label class="section-head">Location Details</ion-label>
                </ion-col>
            </ion-row>
            <ion-row align-items-stretch>
                <ion-col size="12" size-md="9" class="col-padding">
                <ion-row align-items-stretch>
                    <ion-col size="12" size-md="4" class="col-nopadding">
                    <ion-label class="section-item" position="stacked">Building Name</ion-label>
                    <div class="section-desc margin-top-10">{{station.address.line1}}</div>
                    </ion-col>
                    <ion-col size="12" size-md="4" class="col-nopadding">
                    <ion-label class="section-item" position="stacked">Street Address</ion-label>
                    <div class="section-desc margin-top-10">{{station.address.line2}}</div>
                    </ion-col>
                    <ion-col size="12" size-md="4" class="col-nopadding">
                    <ion-label class="section-item" position="stacked">Area Name</ion-label>
                    <div class="section-desc margin-top-10">{{station.address.line3}}</div>
                    </ion-col>
                    <ion-col size="12" size-md="4" class="col-nopadding">
                    <ion-label class="section-item" position="stacked">City</ion-label>
                    <div class="section-desc margin-top-10">{{station.address.city}}</div>
                    </ion-col>
                    <ion-col size="12" size-md="4" class="col-nopadding">
                    <ion-label class="section-item" position="stacked">State</ion-label>
                    <div class="section-desc margin-top-10">{{station.address.state.name}}</div>
                    </ion-col>
                    <ion-col size="12" size-md="4" class="col-nopadding">
                    <ion-label class="section-item" position="stacked">Pincode</ion-label>
                    <div class="section-desc margin-top-10">{{station.address.zipcode}}</div>
                    </ion-col>
                </ion-row>
                </ion-col>
                <ion-col size="12" size-md="3" class="col-padding">
                <ion-row align-items-stretch>
                    <ion-col size="12" size-md="12" class="col-nopadding">
                    <ion-label class="section-item" position="stacked">Landmark</ion-label>
                    <div class="section-desc margin-top-10">{{station.address.landmark}}</div>
                    </ion-col>
                    <ion-col size="12" size-md="6" class="col-nopadding">
                    <ion-label class="section-item" position="stacked">Latitute</ion-label>
                    <div class="section-desc margin-top-10">{{station.coordinate.latitude}}</div>
                    </ion-col>
                    <ion-col size="12" size-md="6" class="col-nopadding">
                    <ion-label class="section-item" position="stacked">Longitute</ion-label>
                    <div class="section-desc margin-top-10">{{station.coordinate.longitude}}</div>
                    </ion-col>
                </ion-row>
                </ion-col>
            </ion-row>
            <hr />
            <ion-row align-items-stretch>
                <ion-col class="col-padding">
                <ion-label class="section-head">Contact Info</ion-label>
                </ion-col>
            </ion-row>
            <ion-row align-items-stretch>
                <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">Telephone</ion-label>
                <div class="section-desc margin-top-10">{{station.landline}}</div>
                </ion-col>
                <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">Mobile</ion-label>
                <div class="section-desc margin-top-10">{{station.mobile}}</div>
                </ion-col>
                <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">Email</ion-label>
                <div class="section-desc margin-top-10">{{station.email}}</div>
                </ion-col>
            </ion-row>
            <hr />
            <ion-row align-items-stretch>
                <ion-col class="col-padding">
                <ion-label class="section-head">Associated Branch</ion-label>
                </ion-col>
            </ion-row>
            <ion-row align-items-stretch>
                <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">Corporate Name</ion-label>
                <div class="section-desc margin-top-10">{{station.branch.corporateName}}</div>
                </ion-col>
                <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">Branch Name</ion-label>
                <div class="section-desc margin-top-10">{{station.branch.branchName}}</div>
                </ion-col>
            </ion-row>
            <hr />
            <ion-grid>
            <ion-row align-items-stretch>
                <ion-col size="10">
                <ion-label class="section-head">Working Hours</ion-label>
                </ion-col>
                <ion-col size="2" class="ion-text-right">
                <ion-icon :icon= workingIconName @click="expandWorkingDetails"></ion-icon>
                </ion-col>
            </ion-row>
            </ion-grid>
            <ion-grid v-if="displayWorkingDetail">
            <ion-row align-items-stretch>
                <ion-col size="12" size-md="3" class="col-padding"></ion-col>
                <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">Opening Time</ion-label>
                </ion-col>
                <ion-col size="12" size-md="3" class="col-padding">
                <ion-label class="section-item" position="stacked">Closing Time</ion-label>
                </ion-col>
            </ion-row>
            <ion-row class="row-divider"></ion-row>
            <ion-row class="row-divider"></ion-row>
                <!--  v-if="index != 7" added three column because need to hide holiday column 18.12.2020 -->
                <ion-row
                align-items-stretch
                v-for="(workHours, index) in this.station.hoursOfOperations"
                :key="index"
                >
                <ion-col size="12" size-md="3" class="col-padding" v-if="index != 7">
                    <ion-label class="section-item" position="stacked">{{workingDays[workHours.weekDay]}}</ion-label>
                </ion-col>
                <ion-col size="12" size-md="3" class="col-padding" v-if="index != 7">
                    <div class="section-desc">{{workHours.opensAt}}</div>
                </ion-col>
                <ion-col size="12" size-md="3" class="col-padding" v-if="index != 7">
                    <div class="section-desc">{{workHours.closesAt}} {{getTimeInfo(workHours.opensAt, workHours.closesAt)}}</div>
                </ion-col>
                </ion-row>
            </ion-grid>

            <!-- Holiday details added by vinoth kumar -->
            <hr />
            <ion-grid>
            <ion-row>
                <ion-col size="10">
                <ion-label class="section-head">Holiday Details</ion-label>
                </ion-col>
                <ion-col size="2" class="ion-text-right">
                <ion-icon :icon= holidayIconName @click="expandHolidayDetails"></ion-icon>
                </ion-col>
            </ion-row>
            </ion-grid>
            <ion-grid v-if="displayHolidayDetails">
                <ion-row v-if="holidayList.length <= 0 ">
                <ion-col class="ion-text-left">
                    <ion-label class="section-item">{{holidayDetails}}</ion-label>
                </ion-col>
                </ion-row>
                <ion-row v-if="holidayList.length > 0 ">
                <ion-col v-for="item in holidayWorkingColumn" v-bind:key="item" class="ion-text-left">
                    <ion-label class="section-item" position="stacked">{{item}}</ion-label>
                </ion-col>
                </ion-row>
                <div v-if="holidayList.length > 0 ">
                <ion-row v-for="holiday of holidayList" :key="holiday" class="ion-text-left">
                    <ion-col class="border-line-holiday-34"><ion-label class="section-item" position="stacked">{{changeDateFormatWithoutTime(holiday.date)}}</ion-label></ion-col>
                    <ion-col class="border-line-holiday-34"><ion-label class="section-item ion-no-padding" position="stacked">{{holiday.year}}</ion-label></ion-col>
                    <ion-col class="border-line-holiday-34"><ion-label class="section-item ion-no-padding" position="stacked">{{holiday.holidayName}}</ion-label></ion-col>
                    <ion-col class="border-line-holiday-34"><ion-label class="section-item" position="stacked" v-if="holiday.startTime != '00:00:00'">{{holiday.startTime}}</ion-label></ion-col>
                    <ion-col class="border-line-holiday-34"><ion-label class="section-item" position="stacked" v-if="holiday.endTime != '00:00:00'">{{holiday.endTime}}</ion-label></ion-col>
                    <ion-col class="border-line-holiday-34"><ion-label class="section-item" position="stacked">{{getStatus(holiday)}}</ion-label></ion-col>
                </ion-row>
                </div>
            </ion-grid>
            </ion-col>
        </ion-row>
        </ion-grid>
        <div class="spinner">
        <ion-spinner v-if="loaderTab"></ion-spinner>
        </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonCol, IonGrid, IonIcon, IonInput, IonLabel, IonRow, IonSpinner } from "@ionic/vue";
import { chevronDown, chevronForward } from 'ionicons/icons';
import moment from "moment";
import { EVCStationService } from "../../service/evcstation/stations.service";
import { EVCStation, EVCStationStatus } from "../../entity/location/evcstation";

import { AppUtils } from "../../util/app-utils";
import { HolidayService } from '@/service/holiday/holiday.service';

import { ToastUtils } from "../../util/toast-utils";
import { tryParseServiceError, migratedTryParseServiceError } from "../../service";


export default defineComponent ({
    name: 'chargingStationView',
    components: {
        IonCol, IonGrid, IonIcon, IonInput, IonLabel, IonRow, IonSpinner
    },
    data() {
        return {
            loaderTab: true,
            station: null,
            workingDays: new AppUtils().getWorkingDays(),
            holidayWorkingColumn: ['Date', 'Year', 'Holiday Name', 'Start Time', 'End Time', 'Status'],
            displayHolidayDetails: false,
            displayWorkingDetail : false,
            workingIconName: chevronForward,
            holidayIconName: chevronForward,
            holidayList: [],
            holidayDetails: ""
        }
    },
    async mounted() {
        let stationIdForView = localStorage.getItem("stationIdForView")
        await new EVCStationService().stationWithId(this.$route.params.stationId, stationIdForView).then((station) => {
            if (station) {
                this.station = station;
            }
            this.loaderTab = false;
        }).catch((error) => {
            this.loaderTab = false;
            let serviceError = migratedTryParseServiceError(error);
            new ToastUtils().presentToast(serviceError.description);
        });

        await new HolidayService().getStationHolidayWorkDet({
        state : this.station.address.state.code,
        stationId: this.station.id
        }).then((holidayList) => {
            if(holidayList.length > 0) {
                this.holidayList = [];
                this.holidayList = holidayList;
                this.loaderTab = false;
            } else {
                this.holidayList = [];
                this.loaderTab = false;
                this.holidayDetails = holidayList.detail;
            }
        }).catch((error) => {
            this.loaderTab = false;
            let serviceError = migratedTryParseServiceError(error);
            new ToastUtils().presentToast(serviceError.description);
        });
        this.loaderTab = false;
    },
    methods: {
        changeDateFormat(dateValue) {
            return moment(dateValue).format('DD/MMM/YYYY HH:mm')
        },
        changeDateFormatWithoutTime(dateValue) {
            if(dateValue != null) {
                return moment(dateValue).format('DD/MMM/YYYY')
            }
        },
        convertUppercase(value) {
            if(value != undefined || value != null) {
                return value.toUpperCase()
            }
        },
        editStation() {
            this.$parent.editStation();
        },
        getTimeInfo(opensAt, closesAt) {
            var retval = "";
            var beginningTime = moment(opensAt, "HH:mm");
            var endTime = moment(closesAt, "HH:mm");
            if (endTime.isBefore(beginningTime)) {
                retval = "(Next day)";
            }
            return retval;
        },
        //getStatus added by vinoth
        getStatus(holiday) {
            if(holiday.startTime === undefined || holiday.startTime === '' || holiday.startTime === '00:00:00' 
            || holiday.endTime === undefined || holiday.endTime === '' || holiday.endTime === '00:00:00' ) {
                //return "InActive";
                return "Active";
            } else {
                return "Active";
            }
        },
        //function added by vinothkumar 18-09-2020
        expandWorkingDetails() {
            if (!this.displayWorkingDetail) {
                this.displayWorkingDetail = true;
                this.workingIconName = chevronDown;
            } else {
                this.displayWorkingDetail = false;
                this.workingIconName = chevronForward;
            }
        },
        expandHolidayDetails() {
            if (!this.displayHolidayDetails) {
                this.displayHolidayDetails = true;
                this.holidayIconName = chevronDown
            } else {
                this.displayHolidayDetails = false;
                this.holidayIconName = chevronForward
            }
        },
    }
})
</script>

<style scoped>
.btn-secondary {
  height: 47px;
  --background: #21315d !important;
  color: #ffffff;
  border-radius: 3px;
  --background-focused: #21315d !important;
  --background-hover: #21315d !important;
  --webkit-background-focused: #21315d !important;
  --webkit-background-hover: #21315d !important;
}
</style>